/**
 * Utility functions for discount calculations and transformations
 */
import i18n from 'modules/core/lib/i18n'

/**
 * Translates period unit to localized string
 */
export const getPeriodUnitTranslation = (unit?: string): string => {
  if (!unit) return ''

  const unitMap: Record<string, string> = {
    year: i18n.t('self_upsell.second_step.discount_periods.year'),
    month: i18n.t('self_upsell.second_step.discount_periods.month'),
    week: i18n.t('self_upsell.second_step.discount_periods.week'),
    day: i18n.t('self_upsell.second_step.discount_periods.day'),
  }

  return unitMap[unit] || unit
}

/**
 * Calculates discount amount from percentage and total price
 */
export const calculateDiscountAmount = (totalPrice: number, discountPercentage: number): number => {
  return totalPrice * (discountPercentage / 100)
}
